import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, ArrowRight, Star, XCircle, CheckCircle2, Zap } from 'lucide-react';
import { MetabolicType } from '../lib/constants';
interface CheckoutPageProps {
  resultType: MetabolicType;
}
const TESTIMONIALS = [{
  name: 'María González',
  location: 'Ciudad de México',
  stars: 5,
  text: 'Llevaba años GORDA y probando dietas. Cuando descubrí mi tipo metabólico todo cambió. En 3 semanas bajé 4 kilos sin pasar hambre.',
  time: 'Hace 2 semanas'
}, {
  name: 'Carlos Ramírez',
  location: 'Bogotá, CO',
  stars: 5,
  text: 'Gasté MILES en nutricionistas que me daban la misma dieta genérica. Esto es diferente — el plan está hecho para MI cuerpo. Más energía que hace 10 años.',
  time: 'Hace 5 días'
}, {
  name: 'Ana Patricia Soto',
  location: 'Lima, PE',
  stars: 5,
  text: 'No te prohíben nada. Comes lo que tu metabolismo necesita y los resultados llegan SOLOS. Bajé 6 kilos en 6 semanas.',
  time: 'Hace 1 semana'
}, {
  name: 'Valentina Herrera',
  location: 'Medellín, CO',
  stars: 5,
  text: 'Tengo 45 años y pensé que ya era tarde. MENTIRA. Mi metabolismo Oso necesitaba algo diferente. Ya perdí 8 kilos y me siento INCREÍBLE.',
  time: 'Hace 4 días'
}];
export function CheckoutPage({
  resultType
}: CheckoutPageProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout');
    }
  }, []);
  const handleCheckout = () => {
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Codigo Metabolico',
        value: 12.99,
        currency: 'USD'
      });
    }
    window.location.href = 'https://pay.hotmart.com/Y104832348Q?checkoutMode=10';
  };
  return <motion.div initial={{
    opacity: 0,
    x: 50
  }} animate={{
    opacity: 1,
    x: 0
  }} className="flex flex-col px-4 pt-6 pb-8 min-h-[100dvh] bg-gray-100 max-w-md mx-auto shadow-xl overflow-y-auto hide-scrollbar relative" data-id="element-82">
      {/* Urgency banner */}
      <div className="w-full bg-red-600 text-white py-2 px-3 rounded-xl mb-6 flex items-center justify-center gap-2 animate-pulse" data-id="element-83">
        <Zap className="w-4 h-4" data-id="element-84" />
        <span className="text-xs font-black uppercase tracking-wide" data-id="element-85">
          Oferta por tiempo limitado — Puede terminar hoy
        </span>
      </div>

      <h1 className="text-2xl font-black text-dark mb-4 leading-tight text-center" data-id="element-86">
        ¿Cuánto pagarías por{' '}
        <span className="text-red-600" data-id="element-87">dejar de estar gorda</span> para siempre?
      </h1>

      {/* Price comparison */}
      <div className="space-y-3 mb-6" data-id="element-88">
        <div className="bg-white rounded-xl p-4 border border-gray-200 flex items-center justify-between opacity-60" data-id="element-89">
          <div className="flex items-start gap-3" data-id="element-90">
            <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-91" />
            <div data-id="element-92">
              <p className="font-bold text-sm text-gray-500 line-through" data-id="element-93">
                Nutricionista
              </p>
              <p className="text-xs text-gray-400" data-id="element-94">
                Dieta genérica. Nunca funciona.
              </p>
            </div>
          </div>
          <span className="text-red-500 font-black text-sm line-through" data-id="element-95">
            $1,500/mes
          </span>
        </div>

        <div className="bg-white rounded-xl p-4 border border-gray-200 flex items-center justify-between opacity-60" data-id="element-96">
          <div className="flex items-start gap-3" data-id="element-97">
            <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-98" />
            <div data-id="element-99">
              <p className="font-bold text-sm text-gray-500 line-through" data-id="element-100">
                Gimnasio
              </p>
              <p className="text-xs text-gray-400" data-id="element-101">
                Sin guía de alimentación. Inútil.
              </p>
            </div>
          </div>
          <span className="text-red-500 font-black text-sm line-through" data-id="element-102">
            $800/mes
          </span>
        </div>

        <div className="bg-white rounded-xl p-4 border border-gray-200 flex items-center justify-between opacity-60" data-id="element-103">
          <div className="flex items-start gap-3" data-id="element-104">
            <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-105" />
            <div data-id="element-106">
              <p className="font-bold text-sm text-gray-500 line-through" data-id="element-107">
                Pastillas / tés
              </p>
              <p className="text-xs text-gray-400" data-id="element-108">Basura que no funciona.</p>
            </div>
          </div>
          <span className="text-red-500 font-black text-sm line-through" data-id="element-109">
            $500/mes
          </span>
        </div>
      </div>

      <div className="bg-dark text-white rounded-xl p-4 mb-6 text-center" data-id="element-110">
        <p className="text-sm font-bold mb-1" data-id="element-111">
          Total que gastas SIN resultados:
        </p>
        <p className="text-3xl font-black text-red-400 line-through" data-id="element-112">
          $2,800+ MXN / mes
        </p>
      </div>

      {/* THE OFFER */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.3
    }} className="bg-white rounded-2xl shadow-2xl border-4 border-primary p-6 mb-6 text-center relative overflow-hidden" data-id="element-113">
        <div className="absolute top-0 left-0 right-0 bg-red-600 text-white text-xs font-black py-1.5 uppercase tracking-wider text-center" data-id="element-114">
          🔥 OFERTA ESPECIAL — SOLO HOY 🔥
        </div>

        <div className="mt-6 mb-4" data-id="element-115">
          <p className="text-sm font-bold text-gray-500 mb-1" data-id="element-116">
            Código Metabólico — Acceso completo
          </p>
          <p className="text-sm font-bold text-gray-500 mb-3" data-id="element-117">
            Plan personalizado para metabolismo{' '}
            <span className="uppercase text-primary" data-id="element-118">{resultType}</span>
          </p>
        </div>

        <div className="flex items-center justify-center gap-2 text-sm mb-2" data-id="element-119">
          <span className="text-gray-400 line-through text-base" data-id="element-120">
            $29.99 USD
          </span>
          <span className="text-dark font-black text-lg" data-id="element-121">$12.99 USD</span>
        </div>

        <div className="flex items-center justify-center gap-3 mb-1" data-id="element-122">
          <span className="text-gray-400 line-through text-xl font-bold" data-id="element-123">
            $513 MXN
          </span>
        </div>
        <div className="text-5xl font-black text-primary mb-2" data-id="element-124">$222 MXN</div>
        <p className="text-xs text-gray-500 font-bold mb-1" data-id="element-125">
          PAGO ÚNICO — Sin suscripción — Acceso de por vida
        </p>
        <p className="text-xs text-green-700 font-black mb-5" data-id="element-126">
          Menos que UNA consulta con un nutricionista que nunca te ayudó.
        </p>

        <motion.button whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="w-full bg-green-600 text-white text-base font-black py-4 rounded-xl shadow-[0_5px_0_rgb(22,163,74)] active:shadow-[0_0px_0_rgb(22,163,74)] active:translate-y-[5px] transition-all flex items-center justify-center gap-2 uppercase tracking-tight" onClick={handleCheckout} data-id="element-127">
          ¡SÍ, QUIERO EMPEZAR HOY!
          <ArrowRight className="w-5 h-5" data-id="element-128" />
        </motion.button>
      </motion.div>

      {/* Testimonials */}
      <div className="text-center mb-4" data-id="element-129">
        <span className="inline-block bg-yellow-100 text-yellow-800 text-xs font-black px-4 py-1.5 rounded-full uppercase tracking-wide" data-id="element-130">
          ⭐ Personas que YA dejaron de estar gordas
        </span>
      </div>

      <div className="space-y-3 mb-6" data-id="element-131">
        {TESTIMONIALS.map((testimonial, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5 + idx * 0.1
      }} className="bg-white rounded-xl border border-gray-200 shadow-sm p-4" data-id="element-132">
            <div className="flex justify-between items-start mb-2" data-id="element-133">
              <div data-id="element-134">
                <h3 className="font-black text-dark text-sm" data-id="element-135">
                  {testimonial.name}
                </h3>
                <p className="text-[10px] text-gray-500" data-id="element-136">
                  {testimonial.location}
                </p>
              </div>
              <div className="flex gap-0.5" data-id="element-137">
                {[...Array(5)].map((_, i) => <Star key={i} className={`w-3 h-3 ${i < testimonial.stars ? 'fill-yellow-400 text-yellow-400' : 'fill-gray-200 text-gray-200'}`} data-id="element-138" />)}
              </div>
            </div>
            <p className="text-xs text-gray-700 leading-relaxed italic" data-id="element-139">
              "{testimonial.text}"
            </p>
          </motion.div>)}
      </div>

      {/* Second CTA */}
      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="w-full bg-green-600 text-white text-base font-black py-4 rounded-xl shadow-[0_5px_0_rgb(22,163,74)] active:shadow-[0_0px_0_rgb(22,163,74)] active:translate-y-[5px] transition-all flex items-center justify-center gap-2 uppercase tracking-tight mb-6" onClick={handleCheckout} data-id="element-140">
        ¡QUIERO TRANSFORMAR MI CUERPO!
        <ArrowRight className="w-6 h-6" data-id="element-141" />
      </motion.button>

      {/* Two paths */}
      <div className="mb-6" data-id="element-142">
        <h3 className="text-lg font-black text-dark text-center mb-4 uppercase" data-id="element-143">
          Hoy tienes DOS caminos:
        </h3>

        <div className="bg-red-50 border-2 border-red-200 rounded-xl p-4 mb-3" data-id="element-144">
          <p className="text-sm text-red-800 font-bold leading-relaxed" data-id="element-145">
            ❌ <strong data-id="element-146">Camino 1:</strong> Cerrar esta página. Seguir gorda.
            Seguir frustrada. Seguir gastando en cosas que no funcionan. Seguir
            odiando tu reflejo.
          </p>
        </div>

        <div className="bg-green-50 border-2 border-green-300 rounded-xl p-4" data-id="element-147">
          <p className="text-sm text-green-800 font-bold leading-relaxed" data-id="element-148">
            ✅ <strong data-id="element-149">Camino 2:</strong> Invertir $222 MXN — menos que una cena
            — y empezar a transformar tu metabolismo{' '}
            <span className="uppercase" data-id="element-150">{resultType}</span> HOY. En 30 días
            puedes estar 5 kilos más delgada.
          </p>
        </div>
      </div>

      {/* Final CTA */}
      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="w-full bg-red-600 text-white text-lg font-black py-4 rounded-xl shadow-[0_5px_0_rgb(185,28,28)] active:shadow-[0_0px_0_rgb(185,28,28)] active:translate-y-[5px] transition-all flex items-center justify-center gap-2 uppercase tracking-tight mb-6" onClick={handleCheckout} data-id="element-151">
        ¡SÍ, QUIERO EMPEZAR HOY!
        <ArrowRight className="w-6 h-6" data-id="element-152" />
      </motion.button>

      {/* Trust */}
      <div className="w-full flex flex-col items-center gap-3 pb-4" data-id="element-153">
        <div className="flex flex-wrap justify-center gap-3 text-gray-500 text-xs font-bold px-2" data-id="element-154">
          <span className="flex items-center gap-1" data-id="element-155">✔ Acceso inmediato</span>
          <span className="flex items-center gap-1" data-id="element-156">
            <ShieldCheck className="w-3.5 h-3.5 text-green-600" data-id="element-157" /> Pago seguro
            Hotmart
          </span>
          <span className="flex items-center gap-1" data-id="element-158">📥 Contenido digital</span>
        </div>
        <p className="text-xs text-gray-400 font-bold text-center px-4" data-id="element-159">
          Si no te funciona, te devolvemos tu dinero. Sin preguntas. Sin
          excusas. Riesgo CERO.
        </p>
      </div>
    </motion.div>;
}